import React, { useState } from "react";
import ChildrenGroup from "../../components/ChildrenGroup";
import { View } from "react-native";
import AddressField from "../../components/address/AddressField";
import SelectField from "../../components/SelectField";
import DateField from "../../components/DateField";
import TextField from "../../components/TextField";
import { Address } from "../../components/address/address";
import type { Meta, StoryObj } from "@storybook/react";

function ChildrenGroupStoryComponent() {
    const [address, setAddress] = useState<Address>();
    const [selectValue, setSelectValue] = useState<string>();
    const [date, setDate] = useState<Date | null>();
    const [text, setText] = useState("");

    return (
        <View style={{ padding: 10, alignSelf: "stretch" }}>
            <ChildrenGroup>
                <AddressField
                    style={{ alignSelf: "stretch" }}
                    value={address}
                    label="Mission address"
                    onSelect={setAddress}
                    inputPlaceholder="Saisisez l'adresse de la mission"
                    allowedCountries={["ch"]}
                />
                <SelectField
                    style={{ alignSelf: "stretch" }}
                    value={selectValue}
                    right="clock"
                    data={Promise.resolve([
                        {
                            label: "Slash",
                            value: "sl",
                        },
                        {
                            label: "Mark Knopfler",
                            value: "mk",
                        },
                        {
                            label: "Carlos Santana",
                            value: "cs",
                        },
                        {
                            label: "Eddie Van Halen",
                            value: "evh",
                        },
                        {
                            label: "Chuck Berry",
                            value: "cb",
                        },
                        {
                            label: "John Petrucci",
                            value: "jp",
                        },
                        {
                            label: "Brian May",
                            value: "bm",
                        },
                    ])}
                    label="Guitarist"
                    searchPlaceholder="Select your guitarist"
                    onSelect={(item) => {
                        setSelectValue(item.value);
                    }}
                />
                <DateField
                    style={{ alignSelf: "stretch" }}
                    value={date}
                    onChange={setDate}
                    label="Birthdate"
                />
                <TextField
                    style={{ alignSelf: "stretch" }}
                    value={text}
                    onChangeText={setText}
                    label="Enter your full name"
                    left="user"
                />
            </ChildrenGroup>
        </View>
    );
}

const meta = {
    title: "Components/Children group",
    component: ChildrenGroupStoryComponent,
    argTypes: {},
} satisfies Meta<typeof ChildrenGroupStoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Basic: Story = {
    args: {},
};
